<template>
  <main class="vh-100">
    <CardContainer :cardHeader="cardHeader" :cardFooter="cardFooter">
      <InputsContainer />
    </CardContainer>
  </main>
</template>
<script>
import { CardContainer } from "@/containers/exporter.js";
import InputsContainer from "./InputsContainer.vue";
export default {
  name: "main",
  data() {
    return {
      cardHeader: {
        title: "Forgot Password",
        subTitle:
          "Please enter the email address that you used to register, and we will send you a link to reset your password via Email.",
      },
      cardFooter: {
        paragraphText: "Return to",
        buttonText: "Sign In",
        buttonClick: () => {
          this.$router.push({ path: "signin" });
        },
      },
    };
  },
  components: {
    CardContainer,
    InputsContainer,
  },
};
</script>

